import React, { useEffect, useState } from 'react'

import history from '../../history'
import VideoList from './VideoList'
import VideoAi from './VideoAi'
import { checkAccess } from '../../services/api/aiVideoGeneration'
import NotFound from '../NotFound'
import { Spin } from 'antd'

const VideoAiHandler = props => {
  const {
    match: {
      params: { id, step }
    }
  } = props

  const [isEdit, setIsEdit] = useState(!!id)
  const [videoId, setVideoId] = useState(id || null)
  const [initialStep, setInitialStep] = useState(step || null)
  const [hasAccess, setHasAccess] = useState(true)

  useEffect(() => {
    // checkUserAccess()
  }, [])

  useEffect(() => {
    if (id) {
      setIsEdit(true)
      setVideoId(id)
      setInitialStep(step || null)
    } else {
      setIsEdit(false)
      setVideoId(null)
      setInitialStep(null)
    }
  }, [id, step])

  const checkUserAccess = async () => {
    try {
      const res = await checkAccess()
      const isAccess = res?.data?.output
      setHasAccess(isAccess || false)
    } catch (error) {
      console.error('Failed to check user access:', error)
      setHasAccess(false)
    }
  }

  const handleEditNavigation = (video, step = 'uploadDocument') => {
    const videoId = video.id
    history.push(`/video-create/${videoId}/${step}`)
  }

  const handleCreateNew = () => {
    setIsEdit(true)
    setVideoId(null)
    setInitialStep(null)
  }

  // Loading state while checking access
  if (hasAccess === null) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '60vh',
          width: '100%'
        }}
      >
        <Spin tip="Checking Access..." size="large" />
      </div>
    )
  }

  if (!hasAccess) {
    return (
      <NotFound text="You don't have access to this feature. Please contact your administrator." />
    )
  }

  if (isEdit) {
    return (
      <VideoAi
        videoId={videoId}
        initialStep={initialStep}
        handleGoBack={() => {
          if (id) {
            history.push('/video-create')
          } else {
            setIsEdit(false)
          }
        }}
      />
    )
  }

  return (
    <VideoList
      onCreateNew={handleCreateNew}
      onEditVideo={handleEditNavigation}
    />
  )
}

export default VideoAiHandler
